import { render } from "./CardCategoryAdmin.vue?vue&type=template&id=630dfbce&scoped=true"
import script from "./CardCategoryAdmin.vue?vue&type=script&lang=js"
export * from "./CardCategoryAdmin.vue?vue&type=script&lang=js"

import "./CardCategoryAdmin.vue?vue&type=style&index=0&id=630dfbce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630dfbce"]])

export default __exports__